export default __webpack_public_path__ + "static/media/alert-circle.645a3c7f.svg";